import { render } from "./BackgroundCircles.vue?vue&type=template&id=54344b28&scoped=true"
import script from "./BackgroundCircles.vue?vue&type=script&lang=js"
export * from "./BackgroundCircles.vue?vue&type=script&lang=js"

import "./BackgroundCircles.vue?vue&type=style&index=0&id=54344b28&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\oi\\Desktop\\TFC\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54344b28"]])

export default __exports__